module.exports = __webpack_public_path__ + "static/media/LogoWhite1.bb0c7c2c.png";